import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import { usePageProps, FAQ as FAQ$1, getCmsInfoForPage } from '@zillow/zrs-cms';
import { event } from '@zillow/universal-analytics';
import { generateBlockList } from '../../components/BlockList/BlockList.js';
import StructuredData from '../../components/StructuredData/StructuredData.js';

var BlockFAQ = function BlockFAQ(_ref) {
  var innerBlocks = _ref.innerBlocks,
    _ref$attrs = _ref.attrs,
    id = _ref$attrs.id,
    allExpanded = _ref$attrs.allExpanded,
    collapseOthers = _ref$attrs.collapseOthers;
  var pageProps = usePageProps();
  var _React$useState = React.useState(function () {
      var expandedIndices = [];
      innerBlocks.forEach(function (item, index) {
        if (item.attrs.expanded || allExpanded) {
          expandedIndices.push(index);
        }
      });

      // If collapseOthers, and more than one panel is default expanded, limit
      // it to the first one.
      if (collapseOthers && expandedIndices.length > 1) {
        expandedIndices.length = 1;
      }
      return expandedIndices;
    }),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    expandedPanelIndices = _React$useState2[0],
    setExpandedPanelIndices = _React$useState2[1];
  var onSelectPanel = function onSelectPanel(index, nextState) {
    // Check if a panel was open or closed.
    if (nextState.includes(index)) {
      var _innerBlocks$index;
      // open
      event({
        // https://dataportal.zillowgroup.net/event-registry/5030
        envelope: {
          event_type_id: '5030',
          event_type_version_id: '1',
          event_template_id: '297',
          event_template_version_id: '1'
          // Master ID: 2284.2.126.1
        },
        clickstream_trigger: {
          trigger_type_nm: 'interaction',
          trigger_location_nm: 'cms',
          trigger_source_nm: 'cms_faq',
          trigger_object_nm: 'no_trigger_object'
        },
        semantic: {
          semantic_event_nm: 'cms_open'
        },
        cms_info: Object.assign({
          block_id: ((_innerBlocks$index = innerBlocks[index]) === null || _innerBlocks$index === void 0 || (_innerBlocks$index = _innerBlocks$index.attrs) === null || _innerBlocks$index === void 0 ? void 0 : _innerBlocks$index.id) || '',
          block_type_cd: 'faq_item'
        }, getCmsInfoForPage(pageProps))
      });
    } else {
      var _innerBlocks$index2;
      // close
      event({
        // https://dataportal.zillowgroup.net/event-registry/2051
        envelope: {
          event_type_id: '2051',
          event_type_version_id: '1',
          event_template_id: '126',
          event_template_version_id: '1'
          // Master ID: 2284.2.126.1
        },
        clickstream_trigger: {
          trigger_type_nm: 'interaction',
          trigger_location_nm: 'cms',
          trigger_source_nm: 'cms_faq',
          trigger_object_nm: 'no_trigger_object'
        },
        semantic: {
          semantic_event_nm: 'cms_close'
        },
        cms_info: Object.assign({
          block_id: ((_innerBlocks$index2 = innerBlocks[index]) === null || _innerBlocks$index2 === void 0 || (_innerBlocks$index2 = _innerBlocks$index2.attrs) === null || _innerBlocks$index2 === void 0 ? void 0 : _innerBlocks$index2.id) || '',
          block_type_cd: 'faq_item'
        }, getCmsInfoForPage(pageProps))
      });
    }
    if (collapseOthers) {
      setExpandedPanelIndices(nextState.includes(index) ? [index] : []);
    } else {
      setExpandedPanelIndices(nextState);
    }
  };
  // Build out structured data.
  var structuredData = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: innerBlocks.map(function (item) {
      var faqName = item.attrs.heading;
      var DD_TAG = '<dd>';
      var DD_CLOSE_TAG = '</dd>';
      var indexOfDdTag = item.innerHTML.indexOf(DD_TAG);
      var indexOfDdCloseTag = item.innerHTML.indexOf(DD_CLOSE_TAG);
      var faqAnswerBlocks = item.innerHTML.substring(indexOfDdTag + DD_TAG.length, indexOfDdCloseTag).trim();
      return {
        '@type': 'Question',
        name: faqName,
        acceptedAnswer: {
          '@type': 'Answer',
          text: faqAnswerBlocks
        }
      };
    })
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StructuredData, {
    data: structuredData
  }), /*#__PURE__*/React.createElement(FAQ$1, {
    forwardedAs: "dl",
    id: id,
    expanded: expandedPanelIndices,
    onChange: onSelectPanel
  }, generateBlockList({
    blocks: innerBlocks
  })));
};
BlockFAQ.propTypes = process.env.NODE_ENV !== "production" ? {
  attrs: PropTypes.shape({
    id: PropTypes.string,
    allExpanded: PropTypes.bool
  }).isRequired,
  innerBlocks: PropTypes.arrayOf(PropTypes.shape({
    attrs: PropTypes.shape({
      expanded: PropTypes.bool
    })
  })).isRequired
} : {};
var FAQ = BlockFAQ;

export { FAQ as default };
